// extracted by mini-css-extract-plugin
export var actionArea = "InAppBrowserWarningDialog-module--actionArea--735bd";
export var contentArea = "InAppBrowserWarningDialog-module--contentArea--bbcb6";
export var copyButton = "InAppBrowserWarningDialog-module--copyButton--95f1f";
export var copyButtonIcon = "InAppBrowserWarningDialog-module--copyButtonIcon--a04e5";
export var copySuccess = "InAppBrowserWarningDialog-module--copySuccess--7edab";
export var description = "InAppBrowserWarningDialog-module--description--73714";
export var dialogContent = "InAppBrowserWarningDialog-module--dialogContent--9829d";
export var dialogOverlay = "InAppBrowserWarningDialog-module--dialogOverlay--fbe65";
export var dialogPanel = "InAppBrowserWarningDialog-module--dialogPanel--7bad6";
export var dialogTitle = "InAppBrowserWarningDialog-module--dialogTitle--63ecd";
export var header = "InAppBrowserWarningDialog-module--header--0c738";
export var instructions = "InAppBrowserWarningDialog-module--instructions--39346";
export var instructionsList = "InAppBrowserWarningDialog-module--instructionsList--a7a5e";
export var instructionsTitle = "InAppBrowserWarningDialog-module--instructionsTitle--6046a";
export var note = "InAppBrowserWarningDialog-module--note--77da2";
export var visuallyHidden = "InAppBrowserWarningDialog-module--visuallyHidden--8ad5d";
export var warningIcon = "InAppBrowserWarningDialog-module--warningIcon--23879";
export var warningItem = "InAppBrowserWarningDialog-module--warningItem--89562";
export var warningItemIcon = "InAppBrowserWarningDialog-module--warningItemIcon--cfd96";
export var warningItemText = "InAppBrowserWarningDialog-module--warningItemText--669fb";
export var warningList = "InAppBrowserWarningDialog-module--warningList--9836a";